import React from 'react';
import { cn } from '../../utils/cn';
import { isWhiteLabel } from '../../config/tenantConfig';

interface SliderProps {
  min: number;
  max: number;
  value: number;
  onChange: (next: number) => void;
  step?: number;
  disabled?: boolean;
  className?: string;
  'aria-label'?: string;
}

const Slider: React.FC<SliderProps> = ({
  min,
  max,
  value,
  onChange,
  step = 1,
  disabled,
  className,
  ...rest
}) => {
  const wl = isWhiteLabel();
  const thumbCls = wl
    ? '[&::-webkit-slider-thumb]:bg-zebu-600 [&::-moz-range-thumb]:bg-zebu-600'
    : '[&::-webkit-slider-thumb]:bg-blue-600 [&::-moz-range-thumb]:bg-blue-600';

  return (
    <input
      type="range"
      min={min}
      max={max}
      value={value}
      step={step}
      disabled={disabled}
      onChange={(e) => onChange(parseInt(e.target.value, 10))}
      aria-label={rest['aria-label']}
      className={cn(
        'w-full h-2 bg-gray-200 dark:bg-gray-600 rounded-lg appearance-none cursor-pointer',
        '[&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:shadow',
        '[&::-moz-range-thumb]:w-4 [&::-moz-range-thumb]:h-4 [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:border-0 [&::-moz-range-thumb]:shadow',
        thumbCls,
        disabled && 'opacity-50 cursor-not-allowed',
        className,
      )}
    />
  );
};

export default Slider;
